module.exports = __webpack_public_path__ + "img/Tyres.ca9f753c.jpg";